import { Button, Input } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { moodleApi, moodleModel } from "../../../../entities/Moodle";
import { adminModel } from "../../../../entities/Admin";
import { message } from "antd";

interface Props {
  courseId: string;
  setCourseId: any;
}

const LoadQuizInp = ({ courseId, setCourseId }: Props) => {
  const user = useSelector(adminModel.selectUser);
  const [loading, setLoading] = useState(false);
  const [loadingStartGame, setLoadingStartGame] = useState(false);
  const dispatch = useDispatch();

  const onSubmit = () => {
    setLoading(true);
    moodleApi
      .getCourseBlocks(courseId)
      .then((response) => {
        const blocks = response.data;
        console.log("quizzes", blocks);
        if (response.data?.exception) {
          message.error(response.data.exception)
        } else {
          dispatch(moodleModel.setCourseBlocks(blocks));
        }
      })
      .catch((e) => {
        console.log("ERROR LOAD QUIZES", e);
        message.error(e.response.data)
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onStartGame = () => {
    setLoadingStartGame(true);
    if (user) {
      moodleApi
        .startGame(user.sub, courseId)
        .then((response) => {
          const game = response.data;
          console.log("game", game);
          if (response.data?.message) {
            message.error(response.data.message)
          } else {
            dispatch(moodleModel.setGame(game));
          }
        })
        .catch((e) => {
          console.log("Error start game", e);
          message.error(e)
        })
        .finally(() => {
          setLoadingStartGame(false);
        });
    }
  };

  return (
    <div>
      <div>
        <Input
          value={courseId}
          style={{ maxWidth: 200, marginRight: 20 }}
          addonBefore="Course ID"
          onChange={(e) => setCourseId(e.target.value)}
          disabled={user == null}
        />

        <Button disabled={user == null} onClick={onSubmit} loading={loading}>
          Загрузить курсы
        </Button>

        <Button
          disabled={user == null}
          onClick={onStartGame}
          loading={loadingStartGame}
        >
          Начать игру
        </Button>
      </div>
    </div>
  );
};

export default LoadQuizInp;
